import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  useOutletContext,
} from "react-router-dom";

import Layout from "./pages/layout";
import LayoutEasyMaps from "./pages/layoutEasymaps";
import LayoutEasyMapsPublic from "./pages/layoutEasymapsPublic";
import Construcao from "./pages/construcao";
import Login from "./pages/login";
import Perfil from "./pages/perfil";
import HomeIn from "./pages/homeIn";

//import Acessos from "./pages/Acessos";
import Suporte from "./pages/suporte";
import Chat from "./pages/suporte/chat";
import RelatoriosFlow from "./pages/easyFlow/relatoriosFlow";
import EasyFlow from "./pages/easyFlow";
import Administracao from "./pages/configuracoes/administracao";
import Cadastro from "./pages/cadastro";

import EasyMaps from "./pages/easyMaps";
import EasyReport from "./pages/easyReportOld";
import EasyAdd from "./pages/newEasyAdd";

import SolicitarRedefinirSenha from "./pages/solicitarRedefinirSenha";
import RedefinirSenha from "./pages/redefinirSenha";
import AgendarRelatorio from "./pages/easyReportOld/agendarRelatorio";
import SelectionPage from "./pages/easyReportOld/selectionPage";
import HistoricoRelatorio from "./pages/easyReportOld/agendarRelatorio/historicoRelatorio";
import GerarRelatorio from "./pages/easyReportOld/gerarRelatorio";
import MapaGeolocalizado from "./pages/easyMaps/maps/geolocalizado";
import MapaTopologia from "./pages/easyMaps/maps/topologia";

// import NovoRelatorio from "./pages/easyReport/relatorios/novoRelatorio";
import MapaGeolocalizadoPublic from "./pages/easyMaps/maps/geolocalizadoPublic";
import MapaTopologiaPublic from "./pages/easyMaps/maps/topologiaPublic";
import NotFoundMaps from "./pages/easyMaps/pages/notFound";
import GruposEasyMaps from "./pages/easyMaps/pages/grupos";
import MapasGeolocalizadosEasyMaps from "./pages/easyMaps/pages/geolocalizado";
import MapaTopologiaEasyMaps from "./pages/easyMaps/pages/topologia";
import MapaTopologiaPOPEasyMaps from "./pages/easyMaps/pages/pop";
import MapaGeolocalizadoERP from "./pages/easyMaps/maps/geolocalizadoFTTH";
import ScriptsOnus from "./pages/scriptsOnus";
import EasyLog from "./pages/easyLog";
import { HistoricoEasyLog } from "./pages/easyLog/pages/historico";
import { InsightsEasyLog } from "./pages/easyLog/pages/Insights";
import Configuracoes from "./pages/configuracoes";
import EasyLogConfig from "./pages/configuracoes/easyLogs";
import AccountType from "./pages/cadastro/accountType";
import EasyReportConfig from "./pages/configuracoes/easyReport";
import checkAuthenticated from "./pages/protectedRoute/loaderFunction";
import MapaGeolocalizadoONUs from "./pages/easyMaps/maps/geolocalizadoONUs";
import checkVerififyModules from "./pages/protectedModules/loaderModules";
import ErrorMessageGeral from "./componentes/errorMessage";
import MapasFTTHEasyMaps from "./pages/easyMaps/pages/ftth";
import { socketPublic } from "./services/socket";
import LayoutEasyReport from "./pages/layoutEasyReport/Index";
import Relatorios from "./pages/easyReport/relatorios";
import Agendamento from "./pages/easyReport/agendamento";
import PerfilRelatorio from "./pages/easyReport/perfilRelatorio/Index";
import NewFunction from "./pages/easyReport/newFunction/Index";
import NovoRelatorio from "./pages/easyReport/relatorios/novoRelatorio";
import AgendamentoDetalhado from "./pages/easyReport/agendamento/agendamenoDetalhado";
import NovoAgendamento from "./pages/easyReport/agendamento/novoAgendamento";
import EditarAgendamento from "./pages/easyReport/agendamento/editarAgendamento";
import FunctionPage from "./pages/easyReport/function";
import EditFunction from "./pages/easyReport/function/editFunction";
import Lixeira from "./pages/easyReport/lixeira";
import ModulosConfig from "./pages/configuracoes/modulos";
import AdditionMassHost from "./pages/newEasyAdd/AdditionMassHost";
import { EasyAddProvider } from "./contexts/easyAddContext";

const EasyAddWrapper = () => {
  const context = useOutletContext();
  return (
    <EasyAddProvider>
      <Outlet context={context} />
    </EasyAddProvider>
  );
};

const routers = ({
  socket,
  socketCliente,
  setCheckLogin,
  checkLogin,
  setColorMode,
  colorMode,
}) => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        ErrorBoundary={
          <ErrorMessageGeral
            message={"Algo deu errado ao carregar o sistema"}
          />
        }
      >
        <Route
          path="/login"
          element={<Login setCheckLogin={setCheckLogin} />}
        />
        <Route path="/accountType" element={<AccountType />} />
        <Route path="/resetPassword/:token/:id" element={<RedefinirSenha />} />
        <Route path="/resetPassword" element={<SolicitarRedefinirSenha />} />
        <Route path="*" element={<Navigate replace to="/login" />} />
        <Route path="/cadastro" element={<Cadastro />} />

        {/* Rotas protegidas */}

        {/* Rotas públicas do EasyMaps */}
        <Route
          element={
            <LayoutEasyMapsPublic
              colorMode={colorMode}
              setColorMode={setColorMode}
            />
          }
        >
          <Route
            path="/easyMaps/mapa/public/*"
            element={<Navigate replace to="/easyMaps/pages/notFound" />}
          />
          <Route path="/easyMaps/pages/notFound" element={<NotFoundMaps />} />
          <Route
            path="/easyMaps/mapa/public/geo/:id/:token"
            element={<MapaGeolocalizadoPublic socketCliente={socketCliente} />}
          />
          <Route
            path="/easyMaps/mapa/public/top/:id/:token"
            element={<MapaTopologiaPublic socketCliente={socketCliente} />}
          />

          <Route
            path="/easyMaps/mapa/public/onus/:id/:token"
            element={
              <MapaGeolocalizadoONUs
                isPublic={true}
                socketCliente={socketCliente}
              />
            }
          />
        </Route>

        {/* Rotas principais */}
        <Route
          loader={({ request }) => checkAuthenticated(setCheckLogin, request)}
          fall
          shouldRevalidate={({ currentUrl, nextUrl }) =>
            currentUrl.pathname !== nextUrl.pathname
          }
        >
          <Route
            element={
              <Layout
                socket={socket}
                socketCliente={socketCliente}
                colorMode={colorMode}
                setColorMode={setColorMode}
              />
            }
          >
            <Route path="/homeIn" element={<HomeIn />} />
            <Route
              path="/configuracoes"
              element={<Navigate replace to="/configuracoes/administracao" />}
            />
            <Route element={<Configuracoes />}>
              <Route
                path="/configuracoes/administracao"
                element={<Administracao />}
              />
              <Route
                path="/configuracoes/easyLogs"
                element={<EasyLogConfig />}
              />
              <Route
                path="/configuracoes/easyReport"
                element={<EasyReportConfig />}
              />
              <Route
                path="/configuracoes/modulos"
                element={<ModulosConfig />}
              />
            </Route>
            <Route path="/perfil" element={<Perfil />} />

            {/* Rotas do EasyLog */}
            <Route
              path="/easyLog"
              element={<Navigate replace to="/easyLog/historico" />}
            />
            <Route
              path="/easyLog/*"
              element={<Navigate replace to="/easyLog/historico" />}
            />
            <Route
              element={<EasyLog />}
              loader={() => checkVerififyModules("planoEasyLog")}
            >
              <Route path="/easyLog/historico" element={<HistoricoEasyLog />} />
              <Route path="/easyLog/insights" element={<InsightsEasyLog />} />
            </Route>

            {/* Rotas do EasyAdd */}
            <Route element={<EasyAddWrapper />}>
              <Route
                path="/easyAdd"
                element={<EasyAdd socket={socketCliente} />}
              />
              <Route path="/easyAdd/hosts" element={<AdditionMassHost />} />
            </Route>

            <Route path="/scriptONUs" element={<ScriptsOnus />} />

            {/* Rotas do EasyReport */}
            <Route
              path="/easyReport"
              element={<EasyReport />}
              loader={() => checkVerififyModules("planoEasyReport")}
            >
              <Route
                path="/easyReport/*"
                element={<Navigate replace to="/easyReport/selecionarPagina" />}
              />
              <Route
                path="/easyReport/selecionarPagina"
                element={<SelectionPage />}
              />
              <Route
                path="/easyReport/agendar"
                element={<AgendarRelatorio />}
              />
              <Route path="/easyReport/gerar" element={<GerarRelatorio />} />
              <Route
                path="/easyReport/agendar/novoRelatorio"
                element={<NovoRelatorio />}
              />
              <Route
                path="/easyReport/agendar/historico/:relatorioId"
                element={<HistoricoRelatorio />}
              />
            </Route>

            <Route path="/easySGP" element={<Construcao />} />
            <Route path="/suporte" element={<Suporte socket={socket} />}>
              <Route path="/suporte/:chatId" element={<Chat />} />
            </Route>
            <Route path="/documentacao" element={<Construcao />} />
            <Route path="/easyFlow" element={<EasyFlow />}>
              <Route
                path="/easyFlow/relatoriosFlow"
                element={<RelatoriosFlow />}
              />
            </Route>
          </Route>

          <Route
            loader={() => checkVerififyModules("planoEasyMaps")}
            element={
              <LayoutEasyMaps
                socket={socket}
                socketCliente={socketCliente}
                colorMode={colorMode}
                setColorMode={setColorMode}
                setCheckLogin={setCheckLogin}
              />
            }
          >
            <Route
              path="/easyMaps"
              element={<Navigate replace to="/easyMaps/grupos" />}
            />
            <Route
              path="/easyMaps/*"
              element={<Navigate replace to="/easyMaps/grupos" />}
            />
            <Route path="/easyMaps/pages/notFound" element={<NotFoundMaps />} />

            <Route element={<EasyMaps />}>
              <Route path="/easyMaps/grupos" element={<GruposEasyMaps />} />
              <Route
                path="/easyMaps/mapas/geolocalizado"
                element={<MapasGeolocalizadosEasyMaps />}
              />
              <Route
                path="/easyMaps/mapas/topologia"
                element={<MapaTopologiaEasyMaps />}
              />
              <Route
                path="/easyMaps/mapas/pop"
                element={<MapaTopologiaPOPEasyMaps />}
              />
              <Route
                path="/easyMaps/mapas/ftth"
                element={<MapasFTTHEasyMaps />}
              />
            </Route>

            <Route
              path="/easyMaps/mapa/onus/:id"
              element={<MapaGeolocalizadoONUs socketCliente={socketCliente} />}
            />
            <Route
              path="/easyMaps/mapa/geo/:id"
              element={<MapaGeolocalizado socketCliente={socketCliente} />}
            />
            <Route
              path="/easyMaps/mapa/top/:id"
              element={<MapaTopologia socketCliente={socketCliente} />}
            />
          </Route>
          <Route
            loader={() => checkVerififyModules("planoEasyReport")}
            element={
              <LayoutEasyReport
                socket={socket}
                socketCliente={socketCliente}
                colorMode={colorMode}
                setColorMode={setColorMode}
              />
            }
          >
            <Route path="/easyReportV2" element={<div>home</div>} />
            <Route path="/easyReportV2/relatorios" element={<Relatorios />} />
            <Route
              path="/easyReportV2/novoRelatorio"
              element={<NovoRelatorio />}
            />
            <Route
              path="/easyReportV2/novoRelatorio/:id"
              element={<NovoRelatorio />}
            />
            <Route path="/easyReportV2/agendamento" element={<Agendamento />} />
            <Route
              path="/easyReportV2/agendamento/:id"
              element={<AgendamentoDetalhado />}
            />
            <Route
              path="/easyReportV2/agendamento/novoAgendamento"
              element={<NovoAgendamento />}
            />
            <Route
              path="/easyReportV2/agendamento/editar/:id"
              element={<EditarAgendamento />}
            />
            <Route
              path="/easyReportV2/perfilRelatorios"
              element={<PerfilRelatorio />}
            />
            <Route
              path="/easyReportV2/perfilRelatorios/novaFuncao"
              element={<NewFunction />}
            />
            <Route
              path="/easyReportV2/perfilRelatorios/funcao"
              element={<FunctionPage />}
            />
            <Route
              path="/easyReportV2/perfilRelatorios/funcao/:id"
              element={<EditFunction />}
            />
            <Route path="/easyReportV2/lixeira" element={<Lixeira />} />
          </Route>
        </Route>
      </Route>,
    ),
  );
  router.subscribe((data) => {
    const currentPath = data.location.pathname;
    const nextPath = data.navigation.state === "loading";
    if (nextPath) return;
    if (socketCliente.connected) {
      socketCliente.emit("/log", {
        path: currentPath,
        logsLoginClienteId: JSON.parse(localStorage.getItem("logs")).id,
      });
    }
    // PUBLIC
    if (socketPublic.connected) {
      socketPublic.emit("/log", {
        path: currentPath,
        logsLoginClienteId: JSON.parse(localStorage.getItem("logs")).id,
      });
    }
  });
  return router;
};

export default routers;
